/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/EmailSettings.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Email Settings
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:05 PM (CST)
 *  
 *  Notes:
 *      09/15/2018  NJN     Working on clean up to split out or eliminate code.
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    EMAILSETTINGS_EDIT_CONTAINER_LOADED,
    EMAILSETTINGS_EDIT_CONTAINER_UNLOADED,
    EMAILSETTINGS_EDIT_FORM_LOADED,
    EMAILSETTINGS_EDIT_FORM_UNLOADED
} from '../constants/actionTypeEmailSettings';

const defaultState = {
    refreshList: false,
    emailsettingid: 0,
    server: '',
    smtpport: 0,
    smtpsecure: '',
    username: '',
    password: '',
    fromaddress: '',
    adminemail: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case EMAILSETTINGS_EDIT_CONTAINER_LOADED:
            return {
                ...state,
                emailsettingid: action.payload ? action.payload.emailsettings.emailsettingid : 0,
                server: action.payload ? action.payload.emailsettings.server : '',
                smtpport: action.payload ? action.payload.emailsettings.smtpport : 0,
                smtpsecure: action.payload ? action.payload.emailsettings.smtpsecure : '',
                username: action.payload ? action.payload.emailsettings.username : '',
                password: action.payload ? action.payload.emailsettings.password : '',
                fromaddress: action.payload ? action.payload.emailsettings.fromaddress : '',
                adminemail: action.payload ? action.payload.emailsettings.adminemail : ''
            }
        case EMAILSETTINGS_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case EMAILSETTINGS_EDIT_CONTAINER_UNLOADED:
        case EMAILSETTINGS_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/EmailSettings.js